import SameHeight from 'same-height';

export class SplitContentPanelModule {
    constructor() {
        this.selector();
        this.init();
    }

    selector() {

        $(".split-panel-select").on("change", function (e) {

            e.preventDefault();

            var parentPanel = $(this).val();
            $(".container-component-split-content-panel__grid").hide();
            $(".container-component-split-content-panel__wrapper").hide();
            $("#split-panel-" + containerPanel).show();
        });

        $('.split-content-panel-link').on("click", function(e) {

            e.preventDefault();

            var parentPanel = $(this).attr('data-parent-id');
            var containerPanel = $(this).attr('data-model-id');

            $(".container-component-split-content-panel__grid").hide();
            $(".container-component-split-content-panel__wrapper").hide();
            $("#split-panel-" + parentPanel).show();

            $("#split-content-parent-" + containerPanel).removeClass('restrict-width-mode');
        });
    }

    equalHeights() {
       SameHeight.init(".container-component-split-content-panel__grid--item--content", "screen and (min-width: 992px)");
    }

    init() {
        var that = this;
        this.equalHeights();
    }
}